module.exports = __webpack_public_path__ + "static/media/topic-img4.7c40434c.png";